import { ReactComponent as ArrowLeft } from '@assets/icons/arrow_left.svg';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import * as styles from './styles';
import { ROOT } from '@router/path';

interface FocusableBackButtonProps {
  onEnterPress?: () => void;
  focusKey?: string;
}

const FocusableBackButton: FC<FocusableBackButtonProps> = (props) => {
  const goPreviousPage = () => {
    if (navigate.length > 1) navigate(-1);
    else navigate(ROOT);
  };
  const { onEnterPress = goPreviousPage, focusKey: customFocusKey } = props;
  const navigate = useNavigate();

  const { ref, focused, focusKey } = useFocusable({
    onEnterPress,
    focusKey: customFocusKey
  });

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref}>{<ArrowLeft css={[styles.icon, focused && styles.focused]} />}</div>
    </FocusContext.Provider>
  );
};

export default FocusableBackButton;
